// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.08545 1H19.4997V8.61957H13.5342L20.9138 15.9992H12.9996V23.9134L5.3879 16.3017L5.38253 8.38213L10.471 8.38558L3.08545 1Z"}}]};

const LogoFramerFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-framer-filled',
    ref,
    icon: element,
  },
));

LogoFramerFilledIcon.displayName = 'LogoFramerFilledIcon';

export default LogoFramerFilledIcon;
